import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'td-wb-card-footer',
  template: '<ng-content />',
  styleUrls: ['card-footer.component.scss'],
  host: {
    '[class.td-wb-card-footer--divider]': 'divider()',
    '[class.td-wb-card-footer--center]': 'align() === "center"',
    '[class.td-wb-card-footer--divider--light]': 'colour() === "light"',
    '[class.td-wb-card-footer--start]': 'align() === "start"',
    '[class.td-wb-card-footer--background]': 'surfaced()'
  }
})
export class CardFooterComponent {

  align: InputSignal<'start' | 'center' | 'end'> = input<'start' | 'center' | 'end'>('end');
  colour: InputSignal<'default' | 'light'> = input<'default' | 'light'>('default');
  divider: InputSignal<boolean> = input(false);
  surfaced: InputSignal<boolean> = input(false);

}
